import { Device } from '@capacitor/device';
import { Preferences } from '@capacitor/preferences';

let platformPromise: Promise<string> | undefined;

const getPlatform = (): Promise<string> => {
  if (!platformPromise) {
    platformPromise = Device.getInfo()
      .then((info) => info?.platform || 'web')
      .catch(() => 'web');
  }
  return platformPromise;
};

const get = async (key: string): Promise<string | null> => {
  try {
    const platform = await getPlatform();
    if (platform === 'web') {
      return window?.localStorage?.getItem(key) ?? null;
    }
    const result = await Preferences.get({ key });
    return result?.value ?? null;
  } catch (e) {
    return null;
  }
};

const set = async (key: string, value: string): Promise<void> => {
  try {
    const platform = await getPlatform();
    if (platform === 'web') {
      window?.localStorage?.setItem(key, value);
      return;
    }
    await Preferences.set({ key, value });
  } catch (e) {
    return;
  }
};

const remove = async (key: string): Promise<void> => {
  try {
    const platform = await getPlatform();
    if (platform === 'web') {
      window?.localStorage?.removeItem(key);
      return;
    }
    await Preferences.remove({ key });
  } catch (e) {
    return;
  }
};

const platformStorage = { get, set, remove };

export default platformStorage;
